module.exports = __webpack_public_path__ + "static/img/link_img_ezpay.7c87b71a.svg";